export default __webpack_public_path__ + "static/media/per-ziprecruiter.34a6627b.svg";